import type { CarReportKind, Message } from "@/reducers/messagesSlice"

/**
 * slickagent-pi starts a collision's body with this for clients that don't know
 * `<car-report>` (mobile, notifications). Here the badge says it instead.
 */
const COLLISION_BODY_PREFIX = "🚨 KOLIZJA | "

export const carReportBody = (message: Message): string =>
  message.carReport === "collision" &&
  message.body.startsWith(COLLISION_BODY_PREFIX)
    ? message.body.slice(COLLISION_BODY_PREFIX.length)
    : message.body

export const carReportBubbleClass = (
  kind?: CarReportKind,
): string | undefined =>
  kind === "collision"
    ? "border-l-4 border-red-500 bg-red-50 dark:bg-red-950"
    : undefined
